module.exports = __webpack_public_path__ + "img/W-30.14b5b492.jpg";